import { STATUSES } from '@/constants/common/message.constants'

import { type SiteImportJobExEntity } from '../../aspida/@types'

/**
 * 地点取込ステータス
 */
export type SiteImportJobStatusType = SiteImportJobExEntity['status']

export const SITE_IMPORT_JOB_STATUS_TYPE = {
  /** 取込待ち */
  PENDING: 'PENDING',
  /** 取込中 */
  IMPORTING: 'IMPORTING',
  /** 完了 */
  COMPLETED: 'COMPLETED',
  /** エラー */
  ERROR: 'ERROR'
} as const satisfies Record<SiteImportJobStatusType, SiteImportJobStatusType>

export const SITE_IMPORT_JOB_STATUS_TYPE_LABEL = {
  [SITE_IMPORT_JOB_STATUS_TYPE.PENDING]: STATUSES.PENDING,
  [SITE_IMPORT_JOB_STATUS_TYPE.IMPORTING]: STATUSES.PROCESSING,
  [SITE_IMPORT_JOB_STATUS_TYPE.COMPLETED]: STATUSES.COMPLETED,
  [SITE_IMPORT_JOB_STATUS_TYPE.ERROR]: STATUSES.FAILED
} as const satisfies Record<SiteImportJobStatusType, string>
